import { Injectable } from '@angular/core';
import { APIURL } from '../Constant/API_Urls';
import { ConstantService } from './constant-service';
import { StorageKeys } from '../Constant/StorageKeys';
import { Router } from '@angular/router';
@Injectable(
  {providedIn: 'root'}
)
export class UrlsService {
  public MPID: any;
  public MainUrl: any;
  currentuser: any;
  constructor(
    private constantService: ConstantService,
    public activatedRoute: Router
  ) {
  }
  getMainUrl() {

    if (this.constantService.getSessionStorage(StorageKeys.User))
      this.currentuser = JSON.parse(this.constantService.getSessionStorage(StorageKeys.User));
    if (this.currentuser) {
    }
    if (this.currentuser != null) {
      if (this.currentuser.mpid != null) {
        let defaultMPID = JSON.parse(this.constantService.getSessionStorage(StorageKeys.MPID));
        this.MPID = defaultMPID.defaultMPID;
      }
    }

    this.MainUrl = APIURL.host + APIURL.project_name + this.MPID;
  }
  setAPIURl(url: string) {
    this.getMainUrl();
    return this.MainUrl + "/" + url;
  }
  setAPIURl1(url: string, param1: any) {
    this.getMainUrl();
    return this.MainUrl + "/" + url + param1;
  }
  setAPIURl2(url: string, param1: any, param2: any) {
    this.getMainUrl();
    return this.MainUrl + "/" + url + param1 + "/" + param2;
  }
  setAPIURl3(url: string, param1: any, param2: any, param3: any) {
    this.getMainUrl();
    return this.MainUrl + "/" + url + param1 + "/" + param2 + "/" + param3;
  }
  getMainTabName() {
    let url : any  = this.activatedRoute.url;
    return url.split('/')[2]; 
  }
}
